import { SpeedTest } from "@/components/SpeedTest";
import { TrendingDown } from "lucide-react";
import { SPEED_FACTORS } from "@/data/content";

export default function Medidor() {
  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12" data-testid="medidor-page">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Herramienta</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Medidor de velocidad</h1>
        <p className="text-muted-foreground mt-3">Mide la velocidad de descarga, carga y la latencia de tu conexión directamente desde el navegador.</p>
      </div>

      <SpeedTest />

      <div className="mt-12 rounded-3xl border border-border bg-card p-8">
        <div className="flex items-center gap-2 mb-4"><TrendingDown className="h-5 w-5 text-primary" /><h2 className="font-display text-xl font-bold">¿Por qué mi resultado puede variar?</h2></div>
        <div className="grid md:grid-cols-2 gap-8 text-sm">
          <div>
            <p className="font-semibold mb-3 text-primary">Factores externos al operador</p>
            <ul className="space-y-2 text-muted-foreground">{SPEED_FACTORS.externos.slice(0, 4).map((f) => <li key={f} className="flex gap-2"><span className="h-1.5 w-1.5 rounded-full bg-muted-foreground mt-1.5 shrink-0" />{f}</li>)}</ul>
          </div>
          <div>
            <p className="font-semibold mb-3 text-primary">Recomendaciones</p>
            <ul className="space-y-2 text-muted-foreground">
              <li className="flex gap-2"><span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 shrink-0" />Conéctate por cable de red para mayor precisión.</li>
              <li className="flex gap-2"><span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 shrink-0" />Cierra descargas, streaming y otras apps activas.</li>
              <li className="flex gap-2"><span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 shrink-0" />Desconecta otros dispositivos del WiFi durante la prueba.</li>
              <li className="flex gap-2"><span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 shrink-0" />Realiza varias mediciones en distintos horarios.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
